import { attachmentController, brandController } from '@/apis/core';
import { AttachmentFolder, BrandSuggestionParams } from '@/apis/core/types';

export const getBrandNameAutocompleteOptions = async (
  value: string,
  params: BrandSuggestionParams = {}
) => {
  const suggestions = await brandController.getBrandSuggestions({
    prefix: value,
    limit: 20,
    ...params,
  });
  return suggestions.map((suggestion) => suggestion.brandName);
};

export const getExtVettingReport = async (
  brandUid: string,
  vettingId: string
) => {
  const attachments = await attachmentController.getAttachments(
    brandUid,
    AttachmentFolder.ExternalVettingReport
  );
  const attachment = attachments.find(
    (data) => data.fileName === `${vettingId}.pdf`
  );
  return attachment;
};
